import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import { TableColumns } from 'helpers/tableColumns';
import { useRemoteResource } from 'hooks/useRemoteResource';
import roomTypesSAService from 'services/superadmin/roomTypesSAService';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (v, i) => i + 1
    },
    {
        key: 'name',
        label: 'Название'
    },
    {
        key: 'code',
        label: 'Код типа комнаты'
    },
    {
        key: 'description',
        label: 'Описание'
    },
    TableColumns.createdDate,
]

export const RoomTypesList = () => {
    const [data, loadData, loading] = useRemoteResource(roomTypesSAService.getAll, "");

    const onDelete = async (u) => {
        await roomTypesSAService.delete(u.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Типы комнат">
            <AppAdminTable
                columnConfig={listConfig}
                data={data || []}
                onDelete={onDelete}
                loading={loading}
            />
        </ListPage>
    );
}
